import React from 'react';

const endpointUrl = '/';
const config = window.pageData.data;
export const DataContext = React.createContext({});

export const DataContextConfig = {
  endpointUrl,
  league: config.league,
  currentSeason: config.season,
};
